import * as axios from "axios";
import { AlertType } from "../types/AlertMessage";
import { LoginResponse } from "../types/LoginResponse";
import Api from "./Api";

export default class AccountService extends Api {
  private _endpoint = "/account";

  public async Login(
    username: string,
    password: string
  ): Promise<LoginResponse | undefined> {
    return super
      .init()
      .post<LoginResponse>(this._endpoint + "/login", {
        UsernameOrEmail: username,
        password,
        clientIp: "",
        userAgent: "",
        languageId: 0,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error: axios.AxiosError) => {
        this.showAlert({
          message: (error.response?.data as string) ?? error.message,
          type: AlertType.Error,
        });
        return undefined;
      });
  }

  public async LoginSso(token: string, refreshToken: string): Promise<LoginResponse | undefined> {
    return super
      .init()
      .post<LoginResponse>(this._endpoint + "/loginSso", {
        token,
        refreshToken
      })
      .then((response) => {
        return response.data;
      })
      .catch((error: axios.AxiosError) => {
        this.showAlert({
          message: "Unable to login from SSO, please try manually",
          type: AlertType.Error,
        });
        return undefined;
      });
  }

  public async ForgottenPassword(email: string): Promise<boolean | undefined> {
    return super
      .init()
      .post<boolean>(this._endpoint + "/forgottenPassword", {
        email,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error: axios.AxiosError) => {
        this.showAlert({
          message: (error.response?.data as string) ?? error.message,
          type: AlertType.Error,
        });
        return undefined;
      });
  }

  public async RefreshToken(
    token: string,
    refreshToken: string,
    clientId: string
  ): Promise<any> {
    return super
      .init()
      .post<any>(this._endpoint + "/refreshToken", {
        token,
        refreshToken,
        clientId,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error: axios.AxiosError) => {
        this.showAlert({
          message: (error.response?.data as string) ?? error.message,
          type: AlertType.Error,
        });
        return undefined;
      });
  }
}
